module.exports = __webpack_public_path__ + "static/portfolio-7-a7c22496c492322874d03a92ba3c5d7b.jpg";